<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Baseline or Uplift:" prop="baselineOrUplift">
            <el-select v-model="form.baselineOrUplift">
              <el-option
                v-for="o in options"
                :key="o.value"
                :value="o.value"
                :label="o.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Secure By %:" prop="securedBy">
            <el-input
              onkeyup="value=value.replace(/[^\d]/g,'')"
              style="width: 300px"
              v-model="form.securedBy"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Type:" prop="type">
            <el-select v-model="form.type">
              <el-option
                v-for="o in types"
                :key="o.value"
                :value="o.value"
                :label="o.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    const options = [
      { value: 1, label: 'Baseline' },
      { value: 2, label: 'Uplift' },
    ]
    const types = [
      { value: 1, label: 'Cash Deposit' },
      { value: 2, label: 'Down Payment' },
    ]
    return {
      formName: 'DP',
      options,
      types,
      commonFormData: {},
      form: {
        reviewDays: '',
        baselineOrUplift: '',
        securedBy: '',
        type: '',
      },
      rules: {
        reviewDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        baselineOrUplift: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        securedBy: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        type: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'reviewDays', newValue.reviewDays)
        this.$set(this.form, 'baselineOrUplift', newValue.baselineOrUplift)
        this.$set(this.form, 'securedBy', newValue.securedBy)
        this.$set(this.form, 'type', newValue.type)
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
